export default "__VITE_ASSET__DGdG1uyJ__"